module.exports = __webpack_public_path__ + "img/service_350x500_4.e1ef11eb.jpg";